import { currencyFormat } from '@/lib/data-transformer/gindumacUtils';
import { ProductItem } from '@/lib/types/api';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { AppState } from '@/redux/store';
import { Dialog, Tab } from '@headlessui/react';
import classNames from 'classnames';
import { useState, useEffect } from 'react';
import { setIsRentingModalOpen } from '../forms/NewsLetter/modalSlice';
import { useRouter } from 'next/router';
import { MdInfoOutline } from 'react-icons/md';

export function RentingModalButton({
  product,
  isInHero,
}: {
  product: ProductItem;
  isInHero?: boolean;
}) {
  const { locale } = useRouter();
  const dispatch = useAppDispatch();

  return product.price_renting && locale == 'es-ES' ? (
    <span
      className='flex cursor-pointer items-center space-x-2'
      onClick={() => {
        dispatch(setIsRentingModalOpen(true));
      }}
    >
      <p
        className={classNames('my-2  text-lg lowercase', {
          'bg-white px-2 font-light text-muted-500': isInHero,
        })}
      >
        {currencyFormat(product.price_renting)} / mes
      </p>
      <MdInfoOutline className='bg-transparent text-xl' />
    </span>
  ) : null;
}

export function RentintModal({ product }: { product: ProductItem }) {
  const dispatch = useAppDispatch();
  const { isRentingModalOpen } = useAppSelector(
    (state: AppState) => state.modals
  );
  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    setSelectedTab(0);
  }, [isRentingModalOpen]);

  return (
    <section>
      <RentingModalButton product={product} />
      <style jsx>{`
        label {
          text: white;
        }
      `}</style>
      <Dialog
        open={isRentingModalOpen}
        onClose={() => dispatch(setIsRentingModalOpen(false))}
        className='relative z-50'
      >
        <div className='fixed inset-0 bg-black/70' aria-hidden='true' />

        <div className='fixed inset-0 flex items-center justify-center p-4'>
          <Dialog.Panel className='w-full max-w-3xl rounded bg-white p-4'>
            <Dialog.Title className='flex items-center justify-between'>
              <h1 className='mx-auto my-4 text-center'>GINDUMAC Renting</h1>
              <button className='relative bottom-4'>
                {/* close icon */}
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  className='h-6 w-6 text-brand-500'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                  onClick={() => dispatch(setIsRentingModalOpen(false))}
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M6 18L18 6M6 6l12 12'
                  />
                </svg>
              </button>
            </Dialog.Title>
            <div>
              <Tab.Group onChange={(index) => setSelectedTab(index)}>
                <Tab.List>
                  <Tab
                    className={classNames('w-1/2  py-2 uppercase', {
                      'border-b-2 border-brand-500  text-brand-500':
                        selectedTab === 0,
                    })}
                  >
                    INFORMACIÓN
                  </Tab>
                  <Tab
                    className={classNames('w-1/2  py-2 uppercase', {
                      'border-b-2 border-brand-500  text-brand-500':
                        selectedTab === 1,
                    })}
                  >
                    VENTAJAS
                  </Tab>
                </Tab.List>
                <Tab.Panels className='pt-4 text-brand-500'>
                  <Tab.Panel>
                    Trabajamos con múltiples partners para ofrecer el mínimo
                    interés y una cuota más ajustada.
                    <br />
                    Financiación por medio de renting solo disponible para
                    empresas con razón social en España
                  </Tab.Panel>
                  <Tab.Panel>
                    Solución Integral: Activos y servicios asociados en una
                    misma cuota (instalación, logística, formación...).
                    <br />
                    ‌Es un gasto 100% deducible fiscalmente.
                    <br />
                    ‌No figura en el CIRBE, por lo que no afecta a la capacidad
                    de endeudamiento.
                  </Tab.Panel>
                  <Tab.Panel />
                </Tab.Panels>
              </Tab.Group>
              <div className='mb-8 px-8 text-center' />
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </section>
  );
}
